import { Action, createReducer, on } from '@ngrx/store';
import { ITrusteeCardData } from '@shared/models/trust.model';

import * as tcfTrustInfoActions from '../../actions/trust/trust.actions';

export interface TCFTrustState {
  info: TCFTrustInfo;
  sign: TCFTrustSign;
}

export interface TCFTrustInfo {
  trustName: string;
  trustDate: string;
  ssnOrEIN: string;
  trusteeInformation: ITrusteeCardData[];
}

export interface TCFTrustSign {
  pageNumbers: string;
  signature: string;
  date: string;
}

export const initialState: TCFTrustState = {
  info: {
    trustName: '',
    trustDate: '',
    ssnOrEIN: '',
    trusteeInformation: [],
  },
  sign: {
    pageNumbers: '',
    signature: '',
    date: '',
  },
};

const tcfTrustReducer = createReducer(
  initialState,
  on(tcfTrustInfoActions.TCFTrustInfoUpdate, (state, { payload }) => ({
    ...state,
    info: payload,
  })),
  on(tcfTrustInfoActions.TCFTrustSignUpdate, (state, { payload }) => ({
    ...state,
    sign: payload,
  })),
);

export function reducer(state: TCFTrustState, action: Action) {
  return tcfTrustReducer(state, action);
}

export const geTCFTrustInfo = (state: TCFTrustState) => {
  return state ? state.info : null;
};

export const geTCFTrustSign = (state: TCFTrustState) => {
  return state ? state.sign : null;
};

export const getTCFTrusteeInformation = (state: TCFTrustState) => {
  return state ? state.info.trusteeInformation : null;
};
